export interface ISocketMessage<T, K> {
  name: T;
  payload: K;
}
